/*******************************************************************************
GET THE NO RESULTS FOUND HTML FOR THE SEARCH FEATURE
Returns the HTML needed to display the No Results panel.
*******************************************************************************/

export default function getNoSearchResultsHTML() {
    return `<div class="side-nav__no-results">
        <div class="side-nav__no-results-head">No Pages Found</div>
        <div class="side-nav__no-results-text">Sorry, but we couldn't find any pages that matched your search.</div>
        <div class="side-nav__no-results-text">However, we're always looking for new ideas to improve the site so please email our team and make a suggestion if you have time:</div>
        <a href="mailto:support@rotowire.com">support@rotowire.com</a>
    </div>`;
}
